import untypedItems from "@data/items.json";

import type { Item, ItemsJson } from "@typings/product/item";

const items: ItemsJson = untypedItems as ItemsJson;

export default (itemId: number) => {
  return items[itemId];
};

export const getItemBySlug = (slug: string): Item => {
  return Object.values(items).find((i) => i.information.slug === slug);
};

export const getItemByIdWithVariant = (itemId: number, quantity: string, offerId: string) => {
  const product = items[itemId];

  if (!product) return null;

  const variant = product.variants.find((v) => {
    const matchesOffer = v.name === offerId;

    return matchesOffer;
  });

  if (!variant) return null;

  return {
    item: product,
    variant,
    quantity: +quantity,
  };
};
